import { Link } from "react-router-dom";

export default function HeritageCard() {
  return (
    <section className="py-20">

      <div className="mx-auto grid max-w-xl px-6">
        <Link
          to="/about"
          className="group relative overflow-hidden rounded-2xl shadow-lg"
        >
          <img
            src="/images/image6.jpg"
            alt="Egyesületünk"
            className="h-64 w-full object-cover transition-transform duration-300 group-hover:scale-105"
          />

          <div className="absolute inset-0 bg-black/30 transition-colors group-hover:bg-primary/60" />

          <p className="absolute inset-0 flex items-center justify-center px-4 text-center text-2xl font-semibold text-white drop-shadow-lg">
            Együttesünk
          </p>
        </Link>
      </div>
    </section>
  );
}
